module.exports = __webpack_public_path__ + "static/media/6.fcd2ac5b.jpg";